import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import {ROUTES, URLS} from 'constants/routes';

import {iconPaths} from '../../data';

/** 收尾转化区。设计稿「联系销售团队」为 href="#"，改指站内真实联系页（避免死链）。 */
const Cta: FC = () => {
  const {t} = useTranslation('home');

  return (
    <section className="relative py-24 lg:py-32 bg-white overflow-hidden">
      <div className="absolute inset-0 aurora-bg">
        <div className="aurora-layer aurora-layer-1" style={{opacity: 0.2}} />
        <div className="aurora-layer aurora-layer-2" style={{opacity: 0.15}} />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="scroll-reveal">
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-slate-900 mb-6">
            {t('cta.title1')}
            <br />
            <span className="text-gradient">{t('cta.title2')}</span>
            {t('cta.title3')}
          </h2>
          <p className="text-lg text-slate-500 mb-10 max-w-2xl mx-auto">{t('cta.subtitle')}</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              className="btn-primary inline-flex items-center gap-2 text-white font-semibold px-10 py-4 rounded-md text-base"
              href={URLS.login}
            >
              {t('cta.freeStart')}
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <path d={iconPaths.arrowRight} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <Link
              className="btn-secondary inline-flex items-center gap-2 text-indigo-600 font-semibold px-10 py-4 rounded-md text-base"
              to={ROUTES.contact}
            >
              {t('cta.salesTeam')}
            </Link>
          </div>
          <p className="text-sm text-slate-400 mt-6">{t('cta.note')}</p>
        </div>
      </div>
    </section>
  );
};

export default Cta;
